import { createContext, useContext } from 'react';

interface SpinnerContextInt {
    show: boolean,
    setSpinnerShow: React.Dispatch<React.SetStateAction<boolean>>
}

const SpinnerContext = createContext({
    show: false,
    setSpinnerShow: () => undefined
} as SpinnerContextInt);

const useSpinnerContext = () => useContext(SpinnerContext);

export { SpinnerContext, useSpinnerContext };
